// Client-side Sentry initialization for Next.js 15+.
// Replaces the legacy `sentry.client.config.ts`, which under
// @sentry/nextjs v10 + Next 16 silently fails to bind a client.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/#1-create-instrumentation-clientts

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from "@sentry/nextjs";
import { applySentryScope, buildSentryInit } from "../../scripts/sentry/build-init";
import { sentryBeforeSend } from "../../scripts/sentry/error-filter";

Sentry.init({
  ...buildSentryInit({
    dsn: "https://7092059d9ffc460da7586c77466cefd4@o458855.ingest.sentry.io/5457109",
    app: "apollo",
    runtime: "client",
  }),

  integrations: [],

  beforeSend: sentryBeforeSend,
});

applySentryScope({ app: "apollo", runtime: "client" });
